/**
 * Query-parameter names used to prefill the external booking page. They
 * follow the GoHighLevel calendar prefill convention (owner question Q13:
 * one GHL round-robin calendar per surface).
 */
export const PREFILL_PARAMS = {
  firstName: 'first_name',
  lastName: 'last_name',
  email: 'email',
  phone: 'phone',
};

const isPresent = (value) => value !== undefined && value !== null && String(value).trim() !== '';

/**
 * Returns `baseUrl` with the member's name, e-mail and phone appended as
 * URL-encoded query parameters. Empty values are left out, so the booking page
 * never receives the literal "undefined". Existing query parameters and the
 * hash of `baseUrl` are kept.
 *
 * @param {string} baseUrl - the surface's booking URL (VITE_COACHING_BOOKING_URL_*)
 * @param {{firstName?: string, lastName?: string, email?: string, phone?: string}} prefill
 * @returns {string} the URL to load in the iframe, or '' when `baseUrl` is empty
 */
export const buildBookingUrl = (baseUrl, prefill = {}) => {
  const base = typeof baseUrl === 'string' ? baseUrl.trim() : '';
  if (!base) return '';

  const params = new URLSearchParams();
  Object.entries(PREFILL_PARAMS).forEach(([field, param]) => {
    if (isPresent(prefill[field])) params.append(param, String(prefill[field]).trim());
  });
  const query = params.toString();
  if (!query) return base;

  const hashIndex = base.indexOf('#');
  const withoutHash = hashIndex === -1 ? base : base.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : base.slice(hashIndex);
  let separator = '&';
  if (!withoutHash.includes('?')) separator = '?';
  else if (withoutHash.endsWith('?') || withoutHash.endsWith('&')) separator = '';

  return `${withoutHash}${separator}${query}${hash}`;
};
